import * as TYPES from '../types';

export const addVacanciesAction = (payload) => {
    return {
        type: TYPES.ADD_VACANCIES,
        payload: payload
    };
};

export const getAllVacanciesAction = () => {
    return {
        type: TYPES.GET_ALL_VACANCIES,
    };
};

export const getAllVacanciesActionSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_VACANCIES_SUCCESS,
        payload: payload
    };
};

export const editVacanciesAction = (payload) => {
    return {
        type: TYPES.EDIT_VACANCIES,
        payload: payload
    };
};

export const deleteVacanciesAction = (payload) => {
    return {
        type: TYPES.DELETE_VACANCIES,
        payload: payload
    };
};

export const updateVacanciesStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_VACANCIES_STATUS,
        payload: payload
    };
};
